// European license plate formats supported by FLEXI.
// Mask notation: 0 = digit, A = letter, [X] = optional segment.
const CAR_PLATE_NUMBER_PATTERNS = [
  // France — AA-000-BB
  /^[A-Za-z]{2}-?\d{3}-?[A-Za-z]{2}$/,
  // Czech Republic — 0AA0000
  /^\d[A-Za-z]{2}\d{4}$/,
  // Belgium — 0-AAA-000
  /^\d-[A-Za-z]{3}-\d{3}$/,
  // Germany — A[AA]-A[A]-0000
  /^[A-Za-z]{1,3}-[A-Za-z]{1,2}-\d{4}$/,
  // Switzerland — AA000000 or 000000AA
  /^([A-Za-z]{2}\d{6}|\d{6}[A-Za-z]{2})$/,
  // Spain — 0000AAA
  /^\d{4}[A-Za-z]{3}$/,
  // Italy — AA000AA
  /^[A-Za-z]{2}\d{3}[A-Za-z]{2}$/,
  // Netherlands — AA-00-BB / 00-AA-00 / AA-000-B
  /^([A-Za-z]{2}-\d{2}-[A-Za-z]{2}|\d{2}-[A-Za-z]{2}-\d{2}|[A-Za-z]{2}-\d{3}-[A-Za-z])$/,
  // Portugal — AA-00-BB or AA-00-BBB
  /^[A-Za-z]{2}-\d{2}-[A-Za-z]{2,3}$/,
  // Poland — AA0000[0][A]
  /^[A-Za-z]{2}\d{4,5}[A-Za-z]?$/,
  // Austria — AA-0000A
  /^[A-Za-z]{2}-\d{4}[A-Za-z]$/,
  // Luxembourg — AA0000
  /^[A-Za-z]{2}\d{4}$/,
  // Denmark — AA00000 or AA0000A
  /^[A-Za-z]{2}\d{4,5}[A-Za-z]?$/,
  // Sweden — AAA000
  /^[A-Za-z]{3}\d{3}$/,
  // Finland — AAA-000
  /^[A-Za-z]{3}-\d{3}$/,
  // Ireland — 00-A-000[00]
  /^\d{2}-[A-Za-z]-\d{3,5}$/,
  // United Kingdom — AA00AAA
  /^[A-Za-z]{2}\d{2}[A-Za-z]{3}$/,
  // Greece — AAA-0000
  /^[A-Za-z]{3}-\d{4}$/,
  // Slovakia — AA-000BB
  /^[A-Za-z]{2}-\d{3}[A-Za-z]{2}$/,
  // Hungary — AAA-000
  /^[A-Za-z]{3}-\d{3}$/,
  // Romania — AA-00-BBB or A-00-BBB
  /^[A-Za-z]{1,2}-\d{2}-[A-Za-z]{3}$/,
  // Bulgaria — AA0000BB
  /^[A-Za-z]{2}\d{4}[A-Za-z]{2}$/,
  // Croatia — AA000BB
  /^[A-Za-z]{2}\d{3}[A-Za-z]{2}$/,
  // Slovenia — AAAA000
  /^[A-Za-z]{4}\d{3}$/,
  // Serbia — AA-000-BB
  /^[A-Za-z]{2}-\d{3}-[A-Za-z]{2}$/,
  // Lithuania — AAA-000 or AAA000
  /^[A-Za-z]{3}-?\d{3}$/,
  // Latvia — AA-0000
  /^[A-Za-z]{2}-\d{4}$/,
  // Estonia — AAA0000
  /^[A-Za-z]{3}\d{4}$/,
  // Ukraine — AA0000BB
  /^[A-Za-z]{2}\d{4}[A-Za-z]{2}$/,
  // Belarus — 0000AA-0
  /^\d{4}[A-Za-z]{2}-\d$/,
  // Moldova — AA00AAA
  /^[A-Za-z]{2}\d{2}[A-Za-z]{3}$/,
  // Armenia — 00AA000
  /^\d{2}[A-Za-z]{2}\d{3}$/,
];

export const isValidCarPlateNumber = (value) => {
  const plateNumber = value?.trim();
  if (!plateNumber) return true;
  return CAR_PLATE_NUMBER_PATTERNS.some((pattern) => pattern.test(plateNumber));
};

export const CAR_PLATE_NUMBER_ERROR_MESSAGE = "Format de plaque d'immatriculation non reconnu";
